import { Dispatch, SetStateAction } from 'react';

const snippet = (setCodes: Dispatch<SetStateAction<any>>, actionHttpURL: URL | undefined, actionWssURL: URL | undefined, actionGOWssURL: URL | undefined, rpcUsername: string) => {
  setCodes(() => [
    {
      lang: 'CURL',
      http: actionHttpURL && `curl ${actionHttpURL.href} \\
-X POST \\
-H 'Content-Type:application/json' -d '{ "jsonrpc" : "2.0", "id" : 1, "method": "rpc_methods","params":[] }'`,
    },
    {
      lang: 'WSCAT',
      wss: actionWssURL && `npx wscat -c ${actionWssURL.href}`,
    },
    {
      lang: 'NodeJs',
      http: actionHttpURL && `import axios from "axios";

const data = JSON.stringify({
"jsonrpc": "2.0",
"id": 1,
"method": "rpc_methods",
"params": []
});

const config = {
method: 'post',
url: '${actionHttpURL.href}',
headers: {
  'Content-Type': 'application/json'
},
data : data
};

axios(config)
.then(function (response) {
console.log(JSON.stringify(response.data));
})
.catch(function (error) {
console.log(error);
});`,
      wss: actionWssURL && `import WebSocket from 'ws';

const ws = new WebSocket('${actionWssURL.href}');

ws.on('open', function open() {
  console.log('connected');

// NOTE : use delay to avoid missing messages from server
  setTimeout(() => {
      const msg = {"jsonrpc":"2.0","method":"rpc_methods","params":[],"id":1};
      ws.send(JSON.stringify(msg));
}, 1000);
});
ws.on('message', function message(data) {
console.log('received: %s', data);
});`,
    },
    {
      lang: 'Python',
      http: actionHttpURL && `import requests
                        
url = '${actionHttpURL.href}'
payload = {
"jsonrpc": "2.0",
"id": 1,
"method": "rpc_methods",
"params": []
}
                                  
x = requests.post(url, json = payload)                             
print(x.text)`,
      wss: actionWssURL && `
import asyncio
from websockets import connect
import time
import json

async def hello(uri):
  async with connect(uri) as websocket:
          print('connected')
          time.sleep(1)
          await websocket.send(json.dumps({"jsonrpc":"2.0","method":"rpc_methods","params":[],"id":1}))
          message = await websocket.recv()
          print(message)

asyncio.run(hello("${actionWssURL.href}"))`,
    },
    {
      lang: 'Go',
      http: actionHttpURL && `
package main

import (
"encoding/json"
"fmt"
"io/ioutil"
"log"
"net/http"
"strings"
)

func main() {
data, err := json.Marshal(map[string]interface{}{
 "jsonrpc": "2.0",
 "method":  "rpc_methods",
 "id":      1,
 "params":  []interface{}{},
})
if err != nil {
 log.Fatalf("Marshal error: %v", err)
}

resp, err := http.Post("${actionHttpURL.href}",
 "application/json",
 strings.NewReader(string(data)),
)
if err != nil {
 log.Fatalf("HTTP request error: %v", err)
}
defer resp.Body.Close()

body, err := ioutil.ReadAll(resp.Body)
if err != nil {
 log.Fatalf("ReadAll error: %v", err)
}

fmt.Println(string(body))
}`,
      wss: actionGOWssURL && `package main
import (
  "encoding/base64"
  "log"
  "net/http"
  "os"
  "os/signal"
  "time"
  "github.com/gorilla/websocket"
)
  func main() {
  addr := "${actionGOWssURL.href}"
  username := "${rpcUsername}"
  password := "****"
  headers := http.Header{
    "Authorization": {"Basic " + base64.StdEncoding.EncodeToString([]byte(username+":"+password))},
  }
  interrupt := make(chan os.Signal, 1)
  signal.Notify(interrupt, os.Interrupt)
  log.Printf("connecting to: %s with headers: %v", addr, headers)
  c, _, err := websocket.DefaultDialer.Dial(addr, headers)
  if err != nil {
    log.Fatal("dial error: ", err)
  }
  defer c.Close()
  done := make(chan struct{})
  go func() {
    defer close(done)
    for j := 1; j <= 1; j++ {
      _, message, err := c.ReadMessage()
      if err != nil {
        log.Println("read error:", err)
        return
      }
      log.Printf("received: %s", message)
    }
  }()
  ticker := time.NewTicker(time.Second)
  defer ticker.Stop()
  for {
    select {
    case <-done:
      log.Println("done")
      return
    case <-ticker.C:
      data := \`{ "jsonrpc": "2.0", "id": 1, "method": "rpc_methods", "params": [] }\`
      err = c.WriteMessage(websocket.TextMessage, []byte(data))
      if err != nil {
        log.Println("write error:", err)
        return
      }
      log.Printf("sent: %s", data)
      case <-interrupt:
      log.Println("interrupt")
      err := c.WriteMessage(websocket.CloseMessage, websocket.FormatCloseMessage(websocket.CloseNormalClosure, ""))
      if err != nil {
        log.Println("write close:", err)
        return
      }
      select {
        case <-done:
        case <-time.After(time.Second):
      }
      return
    }
  }
}`,
    },
  ]);
};

export default snippet;